import { useTranslation } from 'react-i18next';
import { ReactSVG } from 'react-svg';
import {
  PaidStatusPill,
  fDate,
  fToCurrency,
  shouldHideInvoiceStatus,
  useParameters,
} from '@web/utils/src';
import arrowTop from '@web/utils/src/assets/icons/functions/arrow-top.svg';
import { InvoiceStatuses } from '@web/utils/src/components/InvoiceStatus/InvoiceStatus';
import { Invoice } from '@/types';
import { TableCell, TableRow } from '@mui/material';

export type PInvoice = Pick<
  Invoice,
  'id' | 'paymentOptions' | 'totalGross' | 'issuedAt'
> & {
  status: InvoiceStatuses;
};

type Props = {
  invoice: PInvoice;
  handleRowClick: (invoice: PInvoice) => void;
};

const SingleInvoice: React.FC<Props> = ({ invoice, handleRowClick }) => {
  const { t } = useTranslation();
  const { retailerId } = useParameters<{ retailerId: string }>();

  return (
    <TableRow
      hover
      key={invoice.id}
      tabIndex={-1}
      role="checkbox"
      className="last:bg-border-0 relative cursor-pointer"
      onClick={() => handleRowClick(invoice)}
    >
      <TableCell align="left">
        <span className="table-cell text-1-4 font-li">{invoice.id}</span>
      </TableCell>
      <TableCell align="left">
        <span className="table-cell text-1-4 font-li">
          {fToCurrency(invoice.totalGross)}
        </span>
      </TableCell>
      <TableCell align="left">
        <span className="table-cell text-1-4 font-li">
          {fDate(invoice.issuedAt)}
        </span>
      </TableCell>
      <TableCell align="left">
        {!shouldHideInvoiceStatus(retailerId) && (
          <PaidStatusPill status={invoice.status} t={t} />
        )}
      </TableCell>

      <TableCell className="absolute right-0 h-full flex items-center px-1-0 cursor-pointer opacity-70 hover:opacity-90">
        <ReactSVG src={arrowTop} className="text-white rotate-90" />
      </TableCell>
    </TableRow>
  );
};

export default SingleInvoice;

{
  /* <TableCell align="left">
    {invoice.status !== 'PAID' &&
      invoice.paymentOptions.length > 0 && (
        <div className="flex w-full justify-between ">
          <div className="text-1-4">
            <ul className="list-disc">
              <li className="leading-1-63">
                {t('invoices.pay_in', {
                  value: '120',
                })}
              </li>
              <li className="leading-1-63">
                {t('invoices.pay_additional', {
                  value: calculateInvoiceFees(
                    invoice.totalGross || 0,
                    invoice.paymentOptions[0].fee,
                  ),
                })}
              </li>
            </ul>
          </div>
          <div className="pr-4-0">
            <Button
              onClick={() =>
                handleCreateInvoicePayment(
                  invoice.id,
                  invoice.paymentOptions[0].id,
                )
              }
            >
              {t('invoices.pay_later')}
            </Button>
          </div>
        </div>
      )}
  </TableCell> */
}
